/** @odoo-module **/

import {Component, mount, xml, useState, useEffect, useRef, onWillStart} from "@odoo/owl";
//import { loadJS } from "@web/core/assets";

function loadCSS(url) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`link[href="${url}"]`)) {
            // already loaded
            resolve();
            return;
        }
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        link.onload = () => resolve();
        link.onerror = () => reject(new Error(`Failed to load CSS: ${url}`));
        document.head.appendChild(link);
    });
}

export class IsTomSelect extends Component {
    static template = 'is_owl_components.IsTomSelect'
    static defaultProps = {
        groupedOptions: false,
        options:[],
        onChange: false,
        required: false,
        value: false,
        settings: {
            maxItems: 99,
        },
        name: '',
        // groups: [{value: 'test', label:'Test'}],
        groups: [],

        valueField: false,
        labelField: false,
        searchField: false,
        load: false, // (query, callback) => { callback(items) }
    };

    setup() {
        var self = this;
        this.state = useState({
          value: self.props.value,
        })
        self.selectEl = useRef('IsTomSelectEl');
        // onWillStart(() => loadJS("https://cdn.jsdelivr.net/npm/tom-select@2.3.1/dist/js/tom-select.complete.min.js"));
        // onWillStart(() => loadCSS("https://cdn.jsdelivr.net/npm/tom-select@2.3.1/dist/css/tom-select.css"));
        useEffect(
            (selectEl) => {
                if (selectEl) {
                    self.select = new TomSelect($(selectEl), {
                        options: self.props.options,
                        optgroups: self.props.groups,
                        optgroupField: 'group',
                        items: self.props.value,
                        load: self.props.load,
                    	valueField: self.props.valueField,
	                    labelField: self.props.labelField,
	                    searchField: self.props.searchField,
                        onChange: self.onChange.bind(self),
                        ...self.props.settings,
                    })
                }
            },
            () => [self.selectEl.el]
        );
        useEffect(
            () => {
                if (self.props.load && self.props.value){
//                    self.select.addOption({id: 123, name: 'abc'});
//                    self.select.addItem(123, true);
                    self.select.addOption(self.props.value);
                    self.select.setValue(self.props.value[self.props.valueField], true);
//                    self.select.addItem(self.props.value[self.props.valueField], true);
                    self.select.refreshOptions(false);
                }
                else if (self.props.value.toString() !== self.state.value.toString()) {
                    debugger
                    self.select.setValue(self.props.value)
                }
            },
            () => [self.props.value]
        );
        useEffect(
            () => {
                if (self.select) {
                    self.select.clearOptions();
                    self.select.addOption(self.props.options);
                    self.select.refreshOptions(false);
                }
            },
            () => [self.props.options]
        );
    }
    onChange(value) {
        var self = this;
        this.state.value = value
        if (self.props.onChange) {
            self.props.onChange(self.state.value)
        }
    }
}
